const states = {
    botbuilder_details: {
        workflows: [],
        workflow_model: [],
        workflow_model_title: "workflow_diagram",
        active_workflow_node_details: {
            message_before: [],
            message_after: []
        },
        active_node_possible_rules:[],
        preemptive_data: {
            actions: [],
            variables: [],
            messages:[],
            event_tags: [],
            event_types: [],
        },
        loaders: {
            workflows_loading: false,
            workflows_loaded: false,
            workflow_model_loading: false,
            workflow_model_loaded: false,
            workflow_diagram_node_changing: false,
        }
    }
};

export default states;


// WEBPACK FOOTER //
// ./src/data/redux/botbuilder_details/states.js